import { render, staticRenderFns } from "./CreateCollectionItem.vue?vue&type=template&id=fcd19ff0&scoped=true&"
import script from "./CreateCollectionItem.vue?vue&type=script&lang=js&"
export * from "./CreateCollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateCollectionItem.vue?vue&type=style&index=0&id=fcd19ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd19ff0",
  null
  
)

export default component.exports